"use client"

import React, { FC } from "react"
import { FragmentType, graphql, useFragment } from "@/gql"
import type { NovaSession } from "@/types"
import { AuthenticatedClientJobDetailsFooter } from "./JobDetailsFooter/AuthenticatedClientJobDetailsFooter"
import { AuthenticatedCreativeJobDetailsFooter } from "./JobDetailsFooter/AuthenticatedCreativeJobDetailsFooter"
import { JobsDrawerFooterSkeleton } from "../../JobsDrawerFooterSkeleton"

const AuthenticatedJobDetailsFooterClientViewerFragment = graphql(`
  fragment AuthenticatedJobDetailsFooterClientViewer on JobPosting {
    __typename
    id

    ...AuthenticatedClientJobDetailsFooter
  }
`)

const AuthenticatedJobDetailsFooterCreativeViewerFragment = graphql(`
  fragment AuthenticatedJobDetailsFooterCreativeViewer on JobPosting {
    __typename
    id

    ...AuthenticatedCreativeJobDetailsFooter
  }
`)

interface Props {
  serverSession: NovaSession
  creativeViewerJobPosting: FragmentType<typeof AuthenticatedJobDetailsFooterCreativeViewerFragment> | undefined | null
  clientViewerJobPosting?: FragmentType<typeof AuthenticatedJobDetailsFooterClientViewerFragment> | undefined | null

  onApply: ({ jobPostingId, positionId }: { jobPostingId: string; positionId: string }) => void
  loading: boolean
  onViewApplication: ({ jobPostingId, positionId }: { jobPostingId: string; positionId: string }) => void
  openSubscriptionCheckoutModal: (jobId: string) => void
}

export const AuthenticatedJobDetailsFooter: FC<Props> = ({
  serverSession,
  onApply,
  loading,
  onViewApplication,
  openSubscriptionCheckoutModal,
  ...props
}) => {
  const creativeViewerJobPosting = useFragment(
    AuthenticatedJobDetailsFooterCreativeViewerFragment,
    props.creativeViewerJobPosting
  )
  const clientViewerJobPosting = useFragment(
    AuthenticatedJobDetailsFooterClientViewerFragment,
    props.clientViewerJobPosting
  )

  if (loading) {
    return <JobsDrawerFooterSkeleton />
  }

  return (
    <>
      {serverSession.account === "creative" ? (
        <AuthenticatedCreativeJobDetailsFooter
          onApply={onApply}
          jobPosting={creativeViewerJobPosting}
          serverSession={serverSession}
          onViewApplication={onViewApplication}
          openSubscriptionCheckoutModal={openSubscriptionCheckoutModal}
        />
      ) : (
        <AuthenticatedClientJobDetailsFooter jobPosting={clientViewerJobPosting} serverSession={serverSession} />
      )}
    </>
  )
}
